module.exports = __webpack_public_path__ + "img/80CA23_B7EE37_D5FA4C_A3E434-256px.2db7f1e5.png";